import Loader from "../Loader/Loader";
import React, { useEffect, useState } from "react";
import { Card } from "antd";
import { withTranslation } from "react-i18next";
import { Pagination, Empty } from "antd";
import MainHeader from "../../components/MainHeader/MainHeader.js";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import "./styles.scss";
import dateFormat from "dateformat";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
function Notification({ t }) {
  const [datas, setData] = useState();
  const [newdatas, setNewData] = useState({});
  const navigate = useNavigate();
  const lan = useSelector((state) => state.langReducer);
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  useEffect(() => {
    axios
      .get(url.url + `/notice?search=read`, {
        headers: headers(),
      })
      .then((res) => {
        setNewData(res.data.data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
      });
    axios
      .get(url.url + `/notice`, {
        headers: headers(),
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
      });
  }, [lan]);
  const handlePage = (e) => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
    axios
      .get(url.url + `/notice?page=${e}`, { headers: headers() })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
      });
  };
  const handleOpen = (id) => {
    navigate({
      pathname: "/account/notic-open",
      search: `?${createSearchParams({
        id: id,
      })}`,
    });
  };
  return (
    <div>
      <MainHeader title={t("Notifications list")}></MainHeader>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Notifications list")}</title>
      </Helmet>
      {!datas ? (
        <div className="ln-cab__empty">
          <Loader />
        </div>
      ) : datas.result?.length > 0 ? (
        <div className="ntf">
          <ul className="ntf__list">
            {datas.result.map((res, i) => (
              <li key={res.id ?? i}>
                <button
                  type="button"
                  className={res.read_at ? "ntf__item" : "ntf__item ntf__item--new"}
                  onClick={() => handleOpen(res.id)}
                >
                  <span className="ntf__icon" aria-hidden="true">
                    <i className={res.read_at ? "bx bx-envelope-open" : "bx bxs-bell-ring"} />
                  </span>
                  <span className="ntf__body">
                    <span className="ntf__head">
                      <strong>{res.message}</strong>
                      <time>{dateFormat(res.created_at, "dd.mm.yyyy")}</time>
                    </span>
                    {res.department ? <span className="ntf__dept">{res.department}</span> : ""}
                    {res.text ? <span className="ntf__text">{res.text}</span> : ""}
                  </span>
                  <i className="bx bx-chevron-right ntf__go" aria-hidden="true" />
                </button>
              </li>
            ))}
          </ul>
          {datas.pagination?.total_pages > 1 || datas.pagination?.total > (datas.pagination?.per_page || 10) ? (
            <div className="pagin">
              <Pagination
                onChange={(e) => handlePage(e)}
                current={datas?.pagination.current_page}
                pageSize={datas?.pagination.per_page}
                total={datas?.pagination.total}
                showSizeChanger={false}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div className="ln-cab__empty">
          <i className="bx bx-bell-off" />
          <p>{t("No data")}</p>
        </div>
      )}
    </div>
  );
}
export default withTranslation()(Notification);
